import { render, staticRenderFns } from "./AuthorizeAppToGetAuthInformation.vue?vue&type=template&id=937b1c86&scoped=true"
import script from "./AuthorizeAppToGetAuthInformation.vue?vue&type=script&lang=js"
export * from "./AuthorizeAppToGetAuthInformation.vue?vue&type=script&lang=js"
import style0 from "./AuthorizeAppToGetAuthInformation.vue?vue&type=style&index=0&id=937b1c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937b1c86",
  null
  
)

export default component.exports